<div class="tooltip bs-tooltip-{{ positionClass }}" [ngClass]="customClass">
  <div class="arrow"></div>
  <div class="tooltip-inner">
    <ng-template #simpleContent>{{ content }}</ng-template>
    <ng-template
      [ngTemplateOutlet]="isTemplate(content) ? content : simpleContent"
    ></ng-template>
  </div>
</div>
